import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getSignature = fp.get('signature');

export const getAll = createSelector(getSignature, fp.get('all'));

export const getSignatureForId = createSelector((_, id) => id, getAll, fp.get);

export const getIsFetching = createSelector(getSignature, fp.get('fetching'));

export const getIsFetched = createSelector(getSignature, fp.get('fetched'));

export const getFetchingError = createSelector(
  getSignature,
  fp.get('fetchingError')
);
